import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    token: db.get('USER_TOKEN'),
    expireTime: db.get('EXPIRE_TIME'),
    user: db.get('USER'),
    permissions: db.get('PERMISSIONS'),
    roles: db.get('ROLES'),
    hospital: db.get('HOSPITAL'),
    requestTime: db.get('REQUEST_TIME')
  },
  mutations: {
    setToken (state, val) {
      db.save('USER_TOKEN', val)
      state.token = val
    },
    setExpireTime (state, val) {
      db.save('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setUser (state, val) {
      db.save('USER', val)
      state.user = val
    },
    setPermissions (state, val) {
      db.save('PERMISSIONS', val)
      state.permissions = val
    },
    setRoles (state, val) {
      db.save('ROLES', val)
      state.roles = val
    },
    setHospital (state, val) {
      db.save('HOSPITAL', val)
      state.hospital = val
    },
    setRequestTime (state, val) {
      db.save('REQUEST_TIME', val)
      state.requestTime = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js